import PropTypes from 'prop-types'

const Cell = ({ time, title, start, end, stickyLabel, labelRef, dayName }) => {
  const style = time.toStyleLeftAndWidth(start, end)
  const isWeekend = stickyLabel
    ? (start.getFullYear() * 12 + start.getMonth()) % 2 !== 0
    : (start.getDay() === 0 || start.getDay() === 6)

  return (
    <div
      className={`rt-timebar__cell${isWeekend ? ' rt-timebar__cell--weekend' : ''}`}
      style={stickyLabel
        ? { ...style, textAlign: 'left' }
        : { ...style, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', lineHeight: 'normal' }
      }
    >
      {stickyLabel ? (
        <span ref={labelRef} style={{ display: 'inline-block', marginLeft: '8px' }}>{title}</span>
      ) : (
        <>
          <span style={{ fontSize: '9px', opacity: 0.65 }}>{dayName}</span>
          <span>{title}</span>
        </>
      )}
    </div>
  )
}

Cell.propTypes = {
  time: PropTypes.shape({
    toStyleLeftAndWidth: PropTypes.func,
  }),
  title: PropTypes.string.isRequired,
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired,
  stickyLabel: PropTypes.bool,
  labelRef: PropTypes.func,
  dayName: PropTypes.string,
}

export default Cell
